/**
 * Motion tokens (design-spec.md §4). Framer Motion from day 1, purposeful.
 * Components gate gesture/entrance motion on useReducedMotion().
 */
import type { Variants, Transition } from 'framer-motion';

export const DUR = { fast: 0.15, base: 0.25, slow: 0.4 } as const;
export const EASE_OUT = [0.16, 1, 0.3, 1] as const;
export const SPRING_SOFT: Transition = { type: 'spring', stiffness: 300, damping: 30 };

export const fadeRise: Variants = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: { duration: DUR.base, ease: EASE_OUT } },
};

export const staggerContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05 } },
};

/** Reduced-motion safe variant: fade only, no translate. */
export const fadeOnly: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: DUR.base } },
};
